import { render, staticRenderFns } from "./MizaProcessPayment.vue?vue&type=template&id=e3552546&ref=bm&"
import script from "./MizaProcessPayment.vue?vue&type=script&lang=js&"
export * from "./MizaProcessPayment.vue?vue&type=script&lang=js&"
import style0 from "./MizaProcessPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports